<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">（旧）全球汇款支付规则查询</h1>
        <AdvancedFeatureNotice api-url="/api/v2/payment/rule/search" />
        <p class="text-gray-600">根据付款国家、银行和币种查询汇款规则与字段要求</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容：接口文档 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                用于查询全球汇款付款规则，支持根据付款国家、银行和币种筛选。
                <br />
                说明：
                <br />- 所有参数均为可选 <br />- 返回匹配的付款规则列表，包含动态字段配置
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                  >GET</span
                >
                <code class="text-sm font-mono">/api/v2/payment/rule/search</code>
              </div>

              <div class="space-y-6">
                <!-- 请求头参数 -->
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">APP ID</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key / AppSecret
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">客户编号</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            Content-Type
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            发送内容类型（与全球汇款制单等接口保持一致）
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            application/json
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 请求参数 -->
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            fromCountryCode
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            string
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            付款账户所在国（ISO 3166-1）
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            CN
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            bank
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            string
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            付款银行 code
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            ICBC
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            currency
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            string
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            付款币种（ISO 4217）
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            USD
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 响应参数 -->
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            字段
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            说明
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr class="bg-gray-50">
                          <td colspan="3" class="px-6 py-2 text-sm font-medium text-gray-900">
                            data（规则列表）
                          </td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">bank</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">适用付款银行（all 表示通用）</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fromCountryCode</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">付款国家</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">toCountryCode</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">收款国家</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">localTransferFlag</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">是否本地清算：1 是 / 0 否</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">supportToAccountCurrency</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">支持的收款币种（CSV 或 ALL）</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">supportFromAccountCurrency</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">支持的付款账户币种</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">supportPaymentCurrency</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">支持的付款币种</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">transferType</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">付款方式 code</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">transferTypeName</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">付款方式中文名</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">limitAmountFrom</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">decimal</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">单笔金额下限</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">limitAmountTo</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">decimal</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">单笔金额上限</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">sameBankFlag</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">同行标识</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">feeAmountPriority</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">手续费优先级</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">deliveryTime</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">到账时效</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fee</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">手续费描述</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">transferTypeLimitAmount</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">付款方式限额描述</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fieldInfo</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">object</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">动态字段配置</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fieldInfo.fromAccountFields</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">array</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">付款方动态字段</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fieldInfo.toAccountFields</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">array</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">收款方动态字段</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">fieldInfo.paymentFields</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">array</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">金额/币种动态字段</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">...fields[].fieldKey</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">字段名</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">...fields[].fieldName</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">中文展示名</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">...fields[].fieldNameEn</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">英文展示名</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">...fields[].require</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">string</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">是否必填：1=是 / 0=否</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 text-sm font-medium text-gray-900">...fields[].validValue</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">array|null</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">字段下拉枚举，为空表示自由输入</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- 成功响应示例 -->
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    成功响应示例
                  </h3>
                  <div class="overflow-x-auto">
                    <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code class="language-json">{
  "status": "OK",
  "data": [
    {
      "bank": "ICBC",
      "fromCountryCode": "CN",
      "toCountryCode": "US",
      "localTransferFlag": "0",
      "supportToAccountCurrency": "USD",
      "supportFromAccountCurrency": "USD,CNY",
      "supportPaymentCurrency": "USD",
      "transferType": "SWIFT",
      "transferTypeName": "电汇",
      "limitAmountFrom": 1.00,
      "limitAmountTo": 999999999.00,
      "sameBankFlag": "",
      "feeAmountPriority": "",
      "deliveryTime": "1-3 个工作日",
      "fee": "20 USD",
      "transferTypeLimitAmount": "",
      "fieldInfo": {
        "fromAccountFields": [
          { "fieldKey": "fromAccountName", "fieldName": "付款人户名", "fieldNameEn": "From Account Name", "require": "1", "validValue": null }
        ],
        "toAccountFields": [
          { "fieldKey": "toAccountCode", "fieldName": "收款人账号", "require": "1", "validValue": null },
          { "fieldKey": "toSwiftCode", "fieldName": "收款方SWIFTCODE/BIC", "require": "1", "validValue": null },
          { "fieldKey": "toAccountType", "fieldName": "收款账户类型", "require": "1",
            "validValue": [ { "code": "0", "name": "对公" }, { "code": "1", "name": "对私" } ] }
        ],
        "paymentFields": [
          { "fieldKey": "payAmount", "fieldName": "收款金额", "require": "1", "validValue": null },
          { "fieldKey": "fee", "fieldName": "费用承担方", "require": "1",
            "validValue": [ { "code": "1", "name": "付款方" }, { "code": "2", "name": "收款方" } ] }
        ]
      }
    }
  ]
}</code></pre>
                  </div>
                </div>

                <!-- 失败响应示例 -->
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    失败响应示例
                  </h3>
                  <div class="overflow-x-auto">
                    <p class="text-sm text-gray-600 mb-2">无业务异常；无匹配规则时返回空数组：</p>
                    <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code class="language-json">{
  "status": "OK",
  "data": []
}</code></pre>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>填写参数并查询汇款规则</CardDescription>
            </CardHeader>
            <CardContent>
              <!-- 语言切换 Tab -->
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <!-- 代码示例区域 -->
              <div class="mt-6">
                <div ref="trySampleCodeRoot">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code :key="`rule-try-${activeLanguage}`">{{ getRequestText() }}</code></pre>
                </div>

                <!-- 表单参数区域 -->
                <div class="space-y-4 mt-6">
                  <!-- Header 参数 -->
                  <div class="border-b border-gray-200 pb-4 mb-2">
                    <h4 class="text-sm font-medium text-gray-900 mb-3">请求头参数</h4>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1"
                        >x-app-id <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="appId"
                        type="text"
                        :class="{ '!border-red-500': showValidation && !appId }"
                        placeholder="请输入 x-app-id"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="block text-sm font-medium text-gray-700 mb-1"
                        >x-app-secret <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="appSecret"
                        type="text"
                        :class="{ '!border-red-500': showValidation && !appSecret }"
                        placeholder="请输入 x-app-secret"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="block text-sm font-medium text-gray-700 mb-1"
                        >x-customer-code <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="customerCode"
                        type="text"
                        :class="{ '!border-red-500': showValidation && !customerCode }"
                        placeholder="请输入 x-customer-code"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="block text-sm font-medium text-gray-700 mb-1"
                        >Content-Type</label
                      >
                      <input
                        type="text"
                        readonly
                        value="application/json"
                        class="w-full px-3 py-2 border border-gray-200 rounded-md shadow-sm bg-gray-50 text-gray-600 text-sm font-mono cursor-default"
                      />
                      <p class="text-xs text-gray-500 mt-1">
                        与开放平台其它接口一致；下方代码示例与实际请求均会携带该请求头。
                      </p>
                    </div>
                  </div>

                  <!-- 业务参数 -->
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >fromCountryCode（付款国家）</label
                    >
                    <input
                      v-model="fromCountryCode"
                      type="text"
                      placeholder="CN"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                    <p class="text-xs text-gray-500 mt-1">ISO 3166-1 国家代码，如：CN、US、GB</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >bank（付款银行）</label
                    >
                    <input
                      v-model="bank"
                      type="text"
                      placeholder="ICBC"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                    <p class="text-xs text-gray-500 mt-1">银行代码，如：ICBC、BOC、ABC</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >currency（付款币种）</label
                    >
                    <input
                      v-model="currency"
                      type="text"
                      placeholder="USD"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                    <p class="text-xs text-gray-500 mt-1">ISO 4217 币种代码，如：USD、EUR、CNY</p>
                  </div>

                  <button
                    @click="searchRules"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "查询中..." : "查询付款规则" }}
                  </button>
                </div>
              </div>

              <!-- 响应结果展示 -->
              <div v-if="response" ref="tryResponseCodeRoot" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto max-h-96 overflow-y-auto"
                ><code :key="`rule-resp-${response.length}`">{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import AdvancedFeatureNotice from "./ui/AdvancedFeatureNotice.vue";
import "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";

const trySampleCodeRoot = ref<HTMLElement | null>(null);
const tryResponseCodeRoot = ref<HTMLElement | null>(null);

const appId = ref("");
const appSecret = ref("");
const customerCode = ref("");
const fromCountryCode = ref("");
const bank = ref("");
const currency = ref("");
const loading = ref(false);
const showValidation = ref(false);
const response = ref("");
const activeLanguage = ref("curl");

const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

/** 「试一试」内代码块与响应 JSON 高亮（限定 ref 根节点，避免处理左侧文档示例） */
const highlightCode = () => {
  nextTick(() => {
    setTimeout(() => {
      const languageMap: Record<string, string> = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };
      const tryLang = languageMap[activeLanguage.value];

      const tryRoots = [trySampleCodeRoot.value].filter(Boolean) as HTMLElement[];
      tryRoots.forEach((root) => {
        root.querySelectorAll("pre code").forEach((el) => {
          const block = el as HTMLElement;
          block.className = "";
          block.removeAttribute("data-highlighted");
          block.classList.add("hljs");
          if (tryLang) block.classList.add(tryLang);
          try {
            hljs.highlightElement(block);
          } catch (e) {
            console.warn("代码高亮失败:", e);
          }
        });
      });

      const respRoots = [tryResponseCodeRoot.value].filter(Boolean) as HTMLElement[];
      respRoots.forEach((root) => {
        root.querySelectorAll("pre code").forEach((el) => {
          const block = el as HTMLElement;
          block.className = "";
          block.removeAttribute("data-highlighted");
          block.classList.add("hljs", "language-json");
          try {
            hljs.highlightElement(block);
          } catch (e) {
            console.warn("响应 JSON 高亮失败:", e);
          }
        });
      });
    }, 100);
  });
};

const getApplicationInfo = async () => {
  try {
    const res = await httpService.get<any>("/nxb/console/application/get");
    return res ? { appId: res.appId, appSecret: res.appSecret } : null;
  } catch (e) {
    return null;
  }
};

const getCustomerInfo = async () => {
  try {
    const res = await httpService.get<any>("/nxb/console/customer/listWithSummary", {
      pageNow: 1,
      pageSize: 10,
    });
    return res?.customers?.[0]?.customerCode || null;
  } catch (e) {
    return null;
  }
};

const autoFetchUserInfo = async () => {
  const user = localStorage.getItem("userInfo");
  if (user) {
    const app = await getApplicationInfo();
    if (app) {
      appId.value = app.appId;
      appSecret.value = app.appSecret;
    }
    const code = await getCustomerInfo();
    if (code) customerCode.value = code;
  } else {
    appId.value = "4d9414e89bc24b0d89b678d9f20bc56a";
    appSecret.value = "8201e508ef948b8fcdca855729e7ee34";
    customerCode.value = "CUSTFA48DD8EFF437956";
  }
};

onMounted(() => {
  highlightCode();
  void autoFetchUserInfo();
});

const getRequestText = () => {
  const base = import.meta.env.VITE_API_URL + "/api/v2/payment/rule/search";
  const p = new URLSearchParams();
  if (fromCountryCode.value) p.append("fromCountryCode", fromCountryCode.value);
  if (bank.value) p.append("bank", bank.value);
  if (currency.value) p.append("currency", currency.value);

  let qs = p.toString() || "fromCountryCode=CN&bank=ICBC&currency=USD";
  const aid = appId.value || "4d9414e89bc24b0d89b678d9f20bc56a";
  const sec = appSecret.value || "8201e508ef948b8fcdca855729e7ee34";
  const ccode = customerCode.value || "CUSTFA48DD8EFF437956";

  switch (activeLanguage.value) {
    case "curl":
      return `curl -X GET '${base}?${qs}' \\\n  -H 'x-app-id: ${aid}' \\\n  -H 'x-app-secret: ${sec}' \\\n  -H 'x-customer-code: ${ccode}' \\\n  -H 'Content-Type: application/json'`;
    case "javascript":
      return `const axios = require('axios');
const config = {
  method: 'get',
  url: '${base}?${qs}',
  headers: {
    'x-app-id': '${aid}',
    'x-app-secret': '${sec}',
    'x-customer-code': '${ccode}',
    'Content-Type': 'application/json'
  }
};
axios(config).then(r => console.log(JSON.stringify(r.data, null, 2))).catch(console.log);`;
    case "python":
      return `import requests
import json
url = "${base}"
params = {
    'fromCountryCode': '${fromCountryCode.value || "CN"}',
    'bank': '${bank.value || "ICBC"}',
    'currency': '${currency.value || "USD"}'
}
headers = {
    'x-app-id': '${aid}',
    'x-app-secret': '${sec}',
    'x-customer-code': '${ccode}',
    'Content-Type': 'application/json'
}
res = requests.get(url, headers=headers, params=params)
print(json.dumps(res.json(), indent=2, ensure_ascii=False))`;
    case "java":
      return `OkHttpClient client = new OkHttpClient();
HttpUrl url = HttpUrl.parse("${base}").newBuilder()
    .addQueryParameter("fromCountryCode", "${fromCountryCode.value || "CN"}")
    .addQueryParameter("bank", "${bank.value || "ICBC"}")
    .addQueryParameter("currency", "${currency.value || "USD"}")
    .build();
Request req = new Request.Builder()
    .url(url)
    .get()
    .addHeader("x-app-id", "${aid}")
    .addHeader("x-app-secret", "${sec}")
    .addHeader("x-customer-code", "${ccode}")
    .addHeader("Content-Type", "application/json")
    .build();
Response res = client.newCall(req).execute();
String json = res.body().string();
System.out.println(json);`;
    case "csharp":
      return `var client = new RestClient("${base}?${qs}");
var req = new RestRequest(Method.GET);
req.AddHeader("x-app-id", "${aid}");
req.AddHeader("x-app-secret", "${sec}");
req.AddHeader("x-customer-code", "${ccode}");
req.AddHeader("Content-Type", "application/json");
IRestResponse res = client.Execute(req);
Console.WriteLine(res.Content);`;
    case "php":
      return `<?php
$curl = curl_init();
curl_setopt_array($curl, [
    CURLOPT_URL => '${base}?${qs}',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_CUSTOMREQUEST => 'GET',
    CURLOPT_HTTPHEADER => [
        'x-app-id: ${aid}',
        'x-app-secret: ${sec}',
        'x-customer-code: ${ccode}',
        'Content-Type: application/json'
    ]
]);
$res = curl_exec($curl);
curl_close($curl);
echo $res;`;
    case "ruby":
      return `require "uri"
require "net/http"
require "json"
url = URI("${base}?${qs}")
https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true
req = Net::HTTP::Get.new(url)
req["x-app-id"] = "${aid}"
req["x-app-secret"] = "${sec}"
req["x-customer-code"] = "${ccode}"
req["Content-Type"] = "application/json"
res = https.request(req)
puts JSON.pretty_generate(JSON.parse(res.body))`;
    default:
      return "";
  }
};

const searchRules = async () => {
  showValidation.value = true;
  if (!appId.value || !appSecret.value || !customerCode.value) return;

  loading.value = true;
  response.value = "";

  try {
    const params: Record<string, string> = {};
    if (fromCountryCode.value) params.fromCountryCode = fromCountryCode.value;
    if (bank.value) params.bank = bank.value;
    if (currency.value) params.currency = currency.value;

    const res = await httpService.get<{ data?: unknown }>(
      "/api/v2/payment/rule/search",
      params,
      {
        headers: {
          "x-app-id": appId.value,
          "x-app-secret": appSecret.value,
          "x-customer-code": customerCode.value,
          "Content-Type": "application/json",
        },
      }
    );

    response.value = JSON.stringify(res?.data ?? res, null, 2);
    highlightCode();
  } catch (err: any) {
    response.value = JSON.stringify(
      err.response?.data || { error: err.message || "请求失败" },
      null,
      2
    );
    highlightCode();
  } finally {
    loading.value = false;
  }
};

watch(
  [
    activeLanguage,
    fromCountryCode,
    bank,
    currency,
    appId,
    appSecret,
    customerCode,
    response,
  ],
  () => highlightCode(),
  { flush: "post" }
);

highlightCode();
</script>
